import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import useModal from '@/hooks/useModal';
import LabelUsingAffixIcon from '@/components/ContextPrinter/LabelUsingAffixIcon';
import SvgSelector from '@/components/Svg/SvgSelector';
import InAAccuse from '@/containers/modal/InA/InAAccuse';
import LoginOrRegist from '@/containers/modal/login/LoginOrRegist';
import { isLoginState } from '@/recoil';

interface IProps {
    contentType: number;
    contentId: number;
}

const AccuseModal = ({ contentType, contentId }: IProps) => {
    const { addModal, removeCurrentModal } = useModal();
    const isLogin = useRecoilValue(isLoginState);

    return (
        <Container
            onClick={() => {
                removeCurrentModal();

                if (isLogin) {
                    addModal({
                        key: 'fullScreen',
                        props: {
                            className: 'movingFocus',
                            content: <InAAccuse contentType={contentType} contentId={contentId} />,
                            handleCloseModal: removeCurrentModal,
                        },
                    });
                } else {
                    addModal({
                        key: 'fullScreen',
                        props: {
                            content: <LoginOrRegist />,
                            handleCloseModal: removeCurrentModal,
                        },
                    });
                }
            }}
        >
            <LabelUsingAffixIcon
                prefixUri={<SvgSelector svg="accuse" width={22} height={22} fill="#ffffff" stroke="#888888" />}
                label="신고하기"
            />
        </Container>
    );
};

const Container = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    align-items: center;
    padding: 23px 0 23px 20px;
`;

export default AccuseModal;
